import { render, staticRenderFns } from "./ResponsibilityDefaultsTab.vue?vue&type=template&id=c9a491b2&scoped=true"
import script from "./ResponsibilityDefaultsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityDefaultsTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityDefaultsTab.vue?vue&type=style&index=0&id=c9a491b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a491b2",
  null
  
)

export default component.exports